'use client';
import { useEffect, useRef, useState } from 'react';
import ShopletterDialog from "./shopLetterButton";
import { useTranslations, useLocale } from "next-intl";
import Image from 'next/image';

const Newshop = () => {
  const t = useTranslations('ShopLetter');
  const l = useLocale();
  const containerRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const [zoom, setZoom] = useState(1);

  // Get localized field
  const getLocalizedField = (item: any, field: string) => 
    item[`${field}_${l}`] || item[`${field}_en`];

  // Multi-language slides
  const slides = [
    {
      id: 4,
      src_en: "/hero-court/padel-court.avif",
      src_ar: "/hero-court/ملعب-بادل.avif",
      src_de: "/hero-court/padel-platz.avif",
      src_es: "/hero-court/pista-de-padel.avif",
      src_fr: "/hero-court/terrain-de-padel.avif",
      src_it: "/hero-court/campo-da-padel.avif",
      src_nl: "/hero-court/padelbaan.avif",
      src_pt: "/hero-court/quadra-de-padel.avif",
      src_ru: "/hero-court/padel-kort.avif",
      src_sv: "/hero-court/padelbana.avif",
      alt: "Padel Court",
      width: 1920,
      height: 1080
    },
    {
      id: 5,
      src_en: "/hero-balls/padel-balls.avif",
      src_ar: "/hero-balls/كرات-بادل.avif",
      src_de: "/hero-balls/padel-baelle.avif",
      src_es: "/hero-balls/bolas-de-padel.avif",
      src_fr: "/hero-balls/balles-de-padel.avif",
      src_it: "/hero-balls/palline-da-padel.avif",
      src_nl: "/hero-balls/padelballen.avif",
      src_pt: "/hero-balls/bolas-de-padel.avif",
      src_ru: "/hero-balls/мячи-падел.avif",
      src_sv: "/hero-balls/padelbollar.avif",
      alt: "Padel Balls",
      width: 1920,
      height: 1080
    },
    {
      id: 6,
      src_en: "/hero-girl/girl-in-padel-court.avif",
      src_ar: "/hero-girl/فتاة-في-ملعب-بادل.avif",
      src_de: "/hero-girl/maedchen-auf-dem-padelplatz.avif",
      src_es: "/hero-girl/chica-en-pista-de-padel.avif",
      src_fr: "/hero-girl/fille-sur-terrain-de-padel.avif",
      src_it: "/hero-girl/ragazza-in-campo-da-padel.avif",
      src_nl: "/hero-girl/meisje-op-padelbaan.avif",
      src_pt: "/hero-girl/menina-em-quadra-de-padel.avif",
      src_ru: "/hero-girl/девушка-на-падел-корте.avif",
      src_sv: "/hero-girl/flicka-pa-padelbana.avif",
      alt: "Girl in Padel Court",
      width: 1920,
      height: 1080
    },
  ];

  useEffect(() => {
    setZoom(1);
    
    const zoomInterval = setInterval(() => {
      setZoom(prev => {
        if (prev >= 1.1) return 1.1;
        return prev + 0.0007;
      });
    }, 50);

    const slideTimer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => {
      clearInterval(slideTimer);
      clearInterval(zoomInterval);
    };
  }, [index]);

  return (
    <div 
      ref={containerRef} 
      className="relative md:h-80 overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
          <Image
            key={slides[index].id}
            src={getLocalizedField(slides[index], "src")}
            alt={slides[index].alt}
            fill
            sizes="100vw"
            className="object-cover"
            style={{
              transform: `scale(${zoom})`,
              transition: 'transform 30ms linear',
            }}
            priority={index === 0}
          />
        </div>
        <div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>
      </div>

      <div className="relative z-20 mx-6 md:mx-20 flex custom:mx-96 justify-center md:justify-between gap-10 py-20 items-center flex-col">
        <h2 className="text-2xl md:text-4xl custom:text-5xl font-extrabold uppercase text-yel text-center drop-shadow-lg">
          {t('title')}
        </h2>
        <ShopletterDialog />
      </div>
    </div>
  );
};

export default Newshop;